import { get } from "lodash-es";

export default {
  computed: {
    userData() {
      return this.$store.getters["auth/getUserData"];
    },

    getColourTheme() {
      const data = this.$store.getters["appPersisted/getColorTheme"];

      if (data !== "" && data !== null && data !== "null") {
        return data;
      }

      const partnerCode = process.env.PARTNER_CODE;

      if (partnerCode) {
        return partnerCode.toLowerCase();
      }

      return "black-and-white";
    },

    // persist state of sidebarMenu
    sidebarMenuPersist() {
      return this.$store.getters["appPersisted/getSidebarMenu"];
    },

    // NOTE:
    // disabled for temporary, needs confirmation
    // get content/label from getters/airtable
    // content() {
    //     let result = {};
    //     if (typeof this.$store.getters['app/getProfileMenu'].QoalaExternalDashboardProfile !== 'undefined') {
    //         result = this.$store.getters['app/getProfileMenu'].QoalaExternalDashboardProfile;
    //     } else {
    //         result = {
    //             profileLanguage: "Language",
    //             profileMyProfile: "My Profile",
    //             profileSignOut: "Log Out"
    //         };
    //     }
    //     return {
    //         QoalaExternalDashboardProfile: result
    //     };
    // },

    computedRouteViewKey() {
      return `${get(this, "routeViewKey.path")}/${get(
        this,
        "routeViewKey.iteration",
      )}`;
    },

    getRouteViewKey() {
      return this.$store.getters["app/getRouteViewKey"];
    },
  },
};
